type SentryClient = {
    init: (options: Record<string, unknown>) => unknown
    isInitialized?: () => boolean
}

type SentryOptionsInput = Record<string, unknown> | (() => Record<string, unknown>)

let initAttempted = false

export function initSentryOnce(
    sentry: SentryClient,
    optionsInput: SentryOptionsInput,
    onDuplicateReplay?: (error: unknown) => void,
): boolean {
    if (initAttempted || sentry.isInitialized?.()) return false

    try {
        const options = typeof optionsInput === 'function' ? optionsInput() : optionsInput
        sentry.init(options)
        initAttempted = true
        return true
    } catch (error) {
        initAttempted = sentry.isInitialized?.() === true
        if (
            error instanceof Error &&
            error.message.includes('Multiple Sentry Session Replay instances are not supported')
        ) {
            initAttempted = true
            onDuplicateReplay?.(error)
            return false
        }
        throw error
    }
}

export function resetSentryInitForTests() {
    initAttempted = false
}
